import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/cmore/ellipse_right.png";
import { StaticImage } from "gatsby-plugin-image";

const Introcmore = () => {
  return (
    <div
      className="intro_cmore p-100"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={7}
            xl={7}
            xxl={7}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/cmore/introduction.png"
              alt="TekRevol"
              className="img-fluid d-none d-md-block"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={942}
            />
            <StaticImage
              src="../../../images/case-studies/cmore/intro_mob.png"
              alt="TekRevol"
              className="img-fluid d-sm-block d-md-none"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={455}
            />
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Introduction <span>CMORE</span>
            </h2>
            <p>
              TekRevol partnered with a client in the construction industry to
              revolutionize the procurement of construction-related goods. The
              project aimed to develop an app named CMORE, an e-commerce
              platform that facilitates the buying, selling, and delivery of
              construction materials, targeting construction material stores and
              builders.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Introcmore;
